import React, { useState } from 'react';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  const [selectedSize, setSelectedSize] = useState('');

  const handleEnquiry = () => {
    let messageText = `Namaste, main *${product.name}* ke baare mein aur jaankari lena chahta hoon.`;

    if (selectedSize) {
      messageText += ` Mujhe *${selectedSize}* size ki enquiry karni hai.`;
    }

    messageText += ` Kripya details share karein.`;

    const message = encodeURIComponent(messageText);
    window.open(`https://wa.me/919911949911?text=${message}`, '_blank');
  };

  return (
    <div className="product-card">
      <div className="product-image">
        <img src={product.image} alt={product.name} loading="lazy" />
        <div className="category-tag">{product.category}</div>
      </div>
      <div className="product-info">
        <h3>{product.name}</h3>
        <p className="description">{product.description}</p>

        {product.sizes && (
          <div className="size-selector">
            <label htmlFor={`size-${product.id}`}>Size:</label>
            <select
              id={`size-${product.id}`}
              value={selectedSize}
              onChange={(e) => setSelectedSize(e.target.value)}
              className={`size-dropdown ${!selectedSize ? 'not-selected' : ''}`}
            >
              <option value="">Select Size</option>
              {product.sizes.map((size, index) => (
                <option key={index} value={size}>{size}</option>
              ))}
            </select>
          </div>
        )}

        {product.specs && (
          <ul className="specs">
            {product.specs.map((spec, index) => (
              <li key={index}>{spec}</li>
            ))}
          </ul>
        )}
        <button className="btn btn-primary enquire-btn" onClick={handleEnquiry}>
          Enquire Now
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
